var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Racer Rewards Rules & FAQs")]),_c('v-card-text',[_c('ContentView',{attrs:{"contentKey":"RACER_RULES_AND_FAQS"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }